/* eslint-disable eqeqeq */

import axios from 'axios';
import moment from 'moment';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const dropdownMapper = res => res.data.map(el => ({ value: el.id, key: el.id, text: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.translations && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name) }));
const dropdownMapperWithObj = res => res.data.map(el => ({
    obj: el, value: el.id, key: el.id, text: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.translations && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name)
}));

const academicTitleDropdownMapper = res => res.data.map(el => ({
    value: el.id,
    key: el.id,
    text: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.translations && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
    description: el.abbreviation + ' '
}));


// const municipalityMapper = res => res.data.map(el => ({
//     value: el.id,
//     key: el.id,
//     text: el.name,
//     canton: el.canton ? el.canton.id : null,
//     entity: el.entity ? el.entity.id : null
// }));

const fetchEntitiesWithDefaultKey = () => axios.get('/entities')
    .then(res => {
        const fbihId = res.data.find(el => el._key === 'fbih').id;
        const entities = res.data.map(el => ({
            value: el.id,
            key: el.id,
            text: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.translations && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name)
        }));
        return {
            entities, fbihId
        };
    });
const fetchOrgUnits = () => axios.get('/graduation-documents/faculties')
    .then(dropdownMapper);
const fetchSocialStatuses = () => axios.get('/social-status-types')
    .then(dropdownMapper);
const fetchInstitutionTypes = () => axios.get('/institution-types')
    .then(dropdownMapper);
const fetchPositions = () => axios.get('/positions')
    .then(dropdownMapper);
const fetchCitizenships = () => axios.get('/countries')
    .then(dropdownMapper);
const fetchNationalities = () => axios.get('nationalities')
    .then(dropdownMapper);
const fetchContactTypes = () => axios.get('contact-types')
    .then(dropdownMapper);
const fetchEducationLevels = () => axios.get('education-levels')
    .then(dropdownMapper);
const fetchCantons = () => axios.get('cantons')
    .then(dropdownMapper);
const fetchMunicipalities = () => axios.get('municipalities')
    .then(dropdownMapper);
const fetchAcademicTitles = () => axios.get('academic-titles')
    .then(academicTitleDropdownMapper);
const fetchCountriesWithDefaultKey = () => axios.get('/countries')
    .then(res => {
        const defaultBiHId = res.data.find(el => el._key === 'bih').id;
        const countries = res.data.map(el => ({
            value: el.id,
            key: el.id,
            text: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.translations && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name)
        }));
        return { countries, bihId: defaultBiHId };
    });
const fetchActivityStatusTypes = () => axios.get('/activity-status-types')
    .then(dropdownMapper);
const fetchOccupationStatuses = () => axios.get('/occupation-statuses')
    .then(dropdownMapper);
const fetchGendersWithDefaultKeys = () => axios.get('/genders')
    .then(res => {
        const defaultMaleGenderId = res.data.find(el => el._key === 'm').id;
        const defaultFemaleGenderId = res.data.find(el => el._key === 'f').id;
        const defaultUndefinedGenderId = res.data.find(el => el._key === 'u').id;
        const genders = res.data.map(el => ({
            value: el.id,
            key: el.id,
            text: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.translations && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name)
        }));
        return {
            genders, defaultMaleGenderId, defaultFemaleGenderId, defaultUndefinedGenderId
        };
    });
const fetchNationalitiesWithDefaultKey = () => axios.get('/nationalities')
    .then(res => {
        const defaultUnknownNationalityId = res.data.find(el => el._key === 'u').id;
        const nationalities = res.data.map(el => ({
            value: el.id,
            key: el.id,
            text: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.translations && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name)
        }));
        return { nationalities, defaultUnknownNationalityId };
    });

const fetchRawFaculties = () => axios.get('/graduation-documents/faculties')
    .then(res => res.data);


const formatPlace = (place, state, withoutStreet) => {
    if (place.place === null && place.address === null) return null;

    let newPlace = {
        name: place.place,
        id: place.placeId ? place.placeId : null,
        optLock: place.placeOptLock ? place.placeOptLock : null,
        country: { id: place.country }

    };

    if (place.country == state.bihId) {
        newPlace = {
            ...newPlace,
            entity: { id: place.entity },
        };
    }
    if (place.entity == state.fbihId) {
        newPlace = {
            ...newPlace,
            canton: { id: place.canton },
            municipality: place.municipality ? { id: place.municipality } : null
        };
    }

    if (place.entity && place.entity != state.fbihId) {
        newPlace = {
            ...newPlace,
            municipality: place.municipality ? { id: place.municipality } : null
        };
    }

    if (withoutStreet) {
        return {
            ...newPlace,
            id: place.id ? place.id : null,
            optLock: place.optLock ? place.optLock : null
        };
    }
    return {
        street: place.address,
        place: newPlace,
        id: place.id ? place.id : null,
        optLock: place.optLock ? place.optLock : null
    };
};

const formatAndValidateForRequest = (state, isEmployee) => {
    // add validation!
    let dateOfBirth;
    try {
        dateOfBirth = moment(state.dateOfBirth).format();
    } catch (e) {
        dateOfBirth = null;
    }
    // mother
    let activityStatusM = {
        status: { id: state.activityStatusTypeM },
    };
    if (activityStatusM.status.id === null) activityStatusM = null;

    if (state.occupationStatusM) { activityStatusM = { ...activityStatusM, occupationStatus: { id: state.occupationStatusM } }; }
    if (state.occupationM) { activityStatusM = { ...activityStatusM, occupation: state.occupationM }; }


    // father
    let activityStatusF = {
        status: { id: state.activityStatusTypeF },
    };
    if (activityStatusF.status.id === null) activityStatusF = null;

    if (state.occupationStatusF) { activityStatusF = { ...activityStatusF, occupationStatus: { id: state.occupationStatusF } }; }
    if (state.occupationF) { activityStatusF = { ...activityStatusF, occupation: state.occupationF }; }


    let person = {
        id: state.studentId,
        firstName: state.firstName,
        lastName: state.lastName,
        maidenName: state.maidenName,
        jmbg: state.jmbg,
        gender: {
            id: state.gender
        },
        dateOfBirth,
        mother: (state.motherFirstName || state.motherLastName) ? {
            firstName: state.motherFirstName,
            lastName: state.motherLastName,
            gender: {
                id: state.motherGender
            },
            id: state.motherId ? state.motherId : null,
            optLock: state.motherOptLock ? state.motherOptLock : null,
            activityStatus: activityStatusM || null
        } : null,
        father: (state.fatherFirstName || state.fatherLastName) ? {
            firstName: state.fatherFirstName,
            lastName: state.fatherLastName,
            gender: {
                id: state.fatherGender
            },
            id: state.fatherId ? state.fatherId : null,
            optLock: state.fatherOptLock ? state.fatherOptLock : null,
            activityStatus: activityStatusF || null

        } : null
    };

    // append nationality if selectedCitizenships include BiH
    if (state.selectedCitizenships.find(el => el === state.bihId)) {
        if (state.nationality) { person = { ...person, nationality: { id: state.nationality } }; }
    }

    const placeOfBirth = formatPlace(state.placeOfBirth, state, true);
    const residence = formatPlace(state.placeOfResidence, state);
    const currentResidence = formatPlace(state.placeOfCurrentResidence, state);

    const personSocialStatuses = state.selectedSocialStatusTypes.map(status => ({

        // id: state.personSocialStatuses.find(el => status === el.socialStatusType.id) ?
        //     state.personSocialStatuses.find(el => status === el.socialStatusType.id).id : null,
        socialStatusType: { id: status }
        // optLock: state.personSocialStatuses.find(el => status === el.socialStatusType.id) ?
        //     state.personSocialStatuses.find(el => status === el.socialStatusType.id).optLock : null,
    }));

    person = {
        ...person,
        placeOfBirth,
        residence,
        currentResidence,
        comment: state.comment,
        optLock: state.optLock
    };
    let citizenships = state.selectedCitizenships.map((c, i) => (
        {
            priority: i === 0 ? 1 : 2,
            country: { id: c }
        }
    ));
    let contacts = state.contacts.map(contact => ({
        value: contact.value,
        contactType: {
            id: contact.contactTypeId
        },
        id: contact.id ? contact.id : null,
        optLock: contact.optLock ? contact.optLock : null
    }));

    // let previousEducations = state.previousEducations.map(el => ({
    //     comment: el.comment,
    //     averageGrade: el.averageGrade,
    //     licenceNumber: el.licenceNumber,
    //     educationLevel: { id: el.educationLevel ? el.educationLevel : null },
    //     institution: { id: el.institution.id },
    //     id: el.id ? el.id : null,
    //     // optLock: el.optLock ? el.optLock : null
    // }));

    let activityStatus;
    let facultyChanges;
    if (!isEmployee) {
        activityStatus = {
            status: { id: state.activityStatusType },
        };
        // if (state.activityStatusType === state.activeStatusId) {
        if (state.occupationStatus) { activityStatus = { ...activityStatus, occupationStatus: { id: state.occupationStatus } }; }
        if (state.occupation) { activityStatus = { ...activityStatus, occupation: state.occupation }; }

        facultyChanges = state.facultyChanges.map(el => ({
            previousFaculty: { id: el.id }
        }));
    }
    let academicTitles;
    if (isEmployee) {
        academicTitles = state.selectedAcademicTitles.map(at => ({
            academicTitle: { id: at.academicTitle.value },
            promotionDate: at.promotionDate,
            expirationDate: at.expirationDate,
        }));
    }
    let personObj = {
        personDTO: {
            person,
            personSocialStatuses,
            citizenships,
            previousEducations: state.previousEducations,
            contacts
        }
    };
    if (isEmployee) {
        personObj = { ...personObj, academicTitles };
    } else {
        personObj = {

            ...personObj, activityStatus, facultyChanges, optLock: state.optLock
        };
    }
    return {
        valid: true,
        errors: {},
        data: personObj,
        isEmployee: !!isEmployee,
    };
};

export default {

    fetchCitizenships,
    fetchNationalities,
    fetchContactTypes,
    fetchEducationLevels,
    fetchAcademicTitles,
    fetchPositions,
    fetchCantons,
    fetchMunicipalities,
    formatAndValidateForRequest,
    fetchCountriesWithDefaultKey,
    fetchGendersWithDefaultKeys,
    fetchNationalitiesWithDefaultKey,
    fetchEntitiesWithDefaultKey,
    fetchActivityStatusTypes,
    fetchOccupationStatuses,
    fetchInstitutionTypes,
    fetchRawFaculties,
    fetchOrgUnits,
    fetchSocialStatuses
};



// WEBPACK FOOTER //
// ./src/views/util/request.js